import React, { useEffect } from "react";

import StepsListView from "components/views/StepsListView";
import { useType } from "api/hooks";
import { useLocation, useNavigate } from "react-router-dom";
import queryString from "query-string";

const GasTypeList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    manufacturerid,
    groupid,
    enginetypeid,
    iframe = false,
  } = queryString.parse(location.search);

  const { data } = useType(enginetypeid);

  const list =
    data && data.types
      ? data.types.map((t) => ({
          label: t.name,
          id: t.type_node_id,
          key: t.prod_rec_key,
          ...t,
        }))
      : data?.types;

  // some entries may appear twice (when they are available with and without catalyst)
  // for those items I show one entry only
  const filteredList =
    list &&
    Object.values(
      list.reduce((acc, current) => {
        acc[current.name] = current;
        return acc;
      }, {})
    );

    useEffect(() => {
      if (data?.skip_gas_type && data?.types?.length > 0) {
        const selectedItems = list.filter((e) => e.name === data?.types[0]?.name);
        const params = `manufacturerid=${manufacturerid}&groupid=${groupid}&enginetypeid=${data?.types[0]?.type_node_id}&gastype=${data?.types[0]?.name}&iframe=${iframe}`;
        const endPoint =
          selectedItems.length === 1
            ? `/results?${params}&catalyst=${data?.types[0]?.catalyst_fitted}`
            : `/catalyst?${params}`;
        
            navigate(`/${endPoint}`);
      }},[data, groupid, iframe, list, manufacturerid, navigate])

  function handleClick(item) {
    const selectedItems = list.filter((e) => e.name === item.name);
    const params = `manufacturerid=${manufacturerid}&groupid=${groupid}&enginetypeid=${item.id}&gastype=${item.name}&iframe=${iframe}`;

    const endPoint =
      selectedItems.length === 1
        ? `/results?${params}&catalyst=${item.catalyst_fitted}`
        : `/catalyst?${params}`;
    navigate(`/${endPoint}`);
  }

  // if there's more than one item we show the accordions
  return <StepsListView list={filteredList || data} onClick={handleClick} />;
};

GasTypeList.displayName = "GasTypeList";

export default GasTypeList;
